export default __webpack_public_path__ + "static/media/withdraws.3618590b.png";